// Use the existing vector as a mask so app marks follow the accent in both
// color schemes. Fixed-white authentication cards use /favicon.svg directly.
export function BrandMark({
  className = "h-8 w-8",
  alt = "",
}: {
  className?: string;
  alt?: string;
}) {
  return (
    <span
      role={alt ? "img" : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      className={`block shrink-0 bg-accent ${className}`}
      style={{
        mask: 'url("/favicon.svg") center / contain no-repeat',
        WebkitMask: 'url("/favicon.svg") center / contain no-repeat',
      }}
    />
  );
}
